var o="@hpstellar/core/tooltip";export{o as tooltipTestId};
